import { Component, computed, inject, output, signal } from '@angular/core';
import { AppNotification } from '../../models/notifications';
import { DatePipe } from '@angular/common';
import { NotificationsService } from '../../api/notifications.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-card',
  imports: [DatePipe],
  templateUrl: './notification-card.component.html',
})
export class NotificationCard {

  readonly service = inject(NotificationsService);
  readonly router = inject(Router);

  // Notifications
  notifications = this.service.currentNotifications;
  loadingNotifications = this.service.loadingNotifications;
  notificationsError = this.service.notificationsError;


  /** Only currently active and unread notifications */
  // UTC dates in ISO format, so can be compared as strings
  activeNotifications = computed(() => {
    const now = new Date().toISOString();
    return this.notifications().filter(n =>
      n.availableFrom <= now &&
      (!n.availableTill || n.availableTill >= now)
    ).sort((a, b) => b.releaseDate.localeCompare(a.releaseDate));
  });

  notReadNotificationsCount = computed(() => {
    return this.activeNotifications().filter(n => !this.notificationRead(n)).length
  });

  ngOnInit() {
    const n = this.service.currentNotifications()
    if (!n) {
      this.service.loadNotifications();
    }
  }

  onClick(n: AppNotification) {
    // 1. Mark as read in the service
    this.service.readNotificationId(n.id);
    // 2. Set active for the detail view
    this.service.selectedNotification.set(n);
    // 3. Navigate
    this.router.navigate(['/notifications']);
  }

  notificationRead(notification: AppNotification) {
    
    return this.service.isRead(notification.id);
  }

}
